<template>
  <div class="app-container" style="padding-top: 35px">
    <!-- 搜索部分 -->
    <div style="width: 50%;display: flex">
      <div>
        <el-input
            v-model="searchForm.title"
            size="small"
            placeholder="搜索标题"
            class="search-input"
            @input="handleSearch">
        </el-input>
      </div>

      <div>
        <el-button type="primary" size="small" @click="fetchTips">搜索</el-button>
      </div>
      <div>
        <el-button type="primary" size="small" style="margin-left: 10px;" @click="AddTips">新增</el-button>
      </div>
      <div>
        <el-button type="primary" size="small" style="margin-left: 10px;">批量删除</el-button>
      </div>
    </div>

    <div style=" display: flex; align-items: center; justify-content: center; margin-top: 20px">
      <el-table
          :data="tipsList"
          border
          style="width: 100%; overflow-y: auto; max-height: 500px;"
          @selection-change="handleSelectionChange">
        <el-table-column
            type="selection"
            width="55px">
        </el-table-column>
        <el-table-column
            type="index"
            label="序号"
            width="55px">
        </el-table-column>
        <el-table-column
            prop="title"
            label="标题"
            width="200px">
        </el-table-column>
        <el-table-column
            prop="context"
            label="内容"
            width="600px">
        </el-table-column>
        <el-table-column
            prop="mode"
            label="模式"
            width="75">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.mode === '0'" type="info">教程</el-tag>
            <el-tag v-else-if="scope.row.mode === '1'" type="success">公告</el-tag>
            <el-tag v-else type="warning">活动</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            prop="createTime"
            label="创建时间"
            width="130">
        </el-table-column>
        <el-table-column
            prop="updateTime"
            label="更新时间"
            width="130">
        </el-table-column>
        <!-- 新增操作列 -->
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" circle @click="handleUpdate(scope.row)">
              <i class="el-icon-edit"></i>
            </el-button>
            <el-button type="text" circle @click="handleDelete(scope.row)">
              <i class="el-icon-delete"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <!-- 分页 -->
      <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalTips">
      </el-pagination>
    </div>
    <el-dialog
        :title="formTitle"
        :visible.sync="dialogVisible"
        width="30%"
        @close="handleDialogClose">
      <el-form :model="currentRow">
        <!-- ... 其他表单项 ... -->
        <el-form-item label="标题" :label-width="formLabelWidth">
          <el-input v-model="currentRow.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="内容" :label-width="formLabelWidth">
          <el-input v-model="currentRow.context" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="模式" :label-width="formLabelWidth">
          <el-select v-model="currentRow.mode" placeholder="请选择">
            <el-option label="教程" value="0"></el-option>
            <el-option label="公告" value="1"></el-option>
            <el-option label="活动" value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- ... 其他表单项 ... -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <!-- 根据 isEditMode 来决定点击按钮是调用新增还是编辑函数 -->
        <el-button type="primary" @click="isEditMode ? handleUpdateConfirm() : handleAddConfirm()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { MessageBox } from 'element-ui';

export default {
  data() {
    return {
      formTitle:'新增Tips',
      isEditMode: false, // 新增一个变量来判断当前是新增模式还是编辑模式
      dialogVisible : false,
      searchForm: {
        title: ''
      },
      tipsList: [],
      totalTips: 0,
      currentPage: 1,
      pageSize: 10,
      multipleSelection: [],
      currentRow: {}, // 当前正在编辑的行
      formLabelWidth: '120px'
    };
  },
  methods: {
    AddTips() {
      this.clearCurrentRow();
      this.dialogVisible = true;
      this.isEditMode = false; // 设置为新增模式
    },
    handleUpdate(scopeRow) {
      this.currentRow = { ...scopeRow };
      this.dialogVisible = true;
      this.isEditMode = true; // 设置为编辑模式
      this.formTitle = '编辑Tips'
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除这个Tips吗?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        this.loading = true;

        // 注意：这里我们将ids作为查询参数传递，而不是在请求体中
        const response = await axios.delete(`/api/admin/tips/delete?ids=${row.id}`, {
          headers: {
            'token': this.$cookies.get('token')
          }
        });
        // 处理正常响应
        this.$message.success('Tips成功被删除');
        await this.fetchTips();

      } catch (error) {
        if (error.response && error.response.data) {
          this.$message.error('Tips删除错误: ' + (error.response.data.message || '错误请求和信息'));
        }
      } finally {
        this.loading = false;
      }
    },
    clearCurrentRow() {
      this.currentRow = {}; // 清空当前行数据
    },
    async handleUpdateConfirm()  {
      try {
        this.dialogVisible = false; // 关闭对话框

        // 设置loading为true，表示开始处理更新请求
        this.loading = true;

        // 创建 PUT 请求的请求体，确保包含 id 字段
        const requestBody = {
          id: this.currentRow.id, // 确保这里提供了id
          title: this.currentRow.title,
          context: this.currentRow.context,
          mode: this.currentRow.mode
        };

        // 发送 PUT 请求到 /update 路径
        const response = await axios.put(`/api/admin/tips/update`, requestBody, {
          headers: {
            'token': this.$cookies.get('token') // 通过请求头发送token
          }
        });

        // 处理正常响应
        this.$message.success('Tips成功更新');

        // 可能需要更新列表或执行其他相关操作
        // ...
        await this.fetchTips();

      } catch (error) {
        // 处理错误
        this.$message.error('Tips更新失败: ' + error.message);
      } finally {
        this.loading = false; // 结束更新请求，无论成功或失败，设置loading为false
      }
    },
    async handleAddConfirm() {
      try {
        // 关闭对话框
        this.dialogVisible = false;

        // 设置loading为true，表示开始处理添加请求
        this.loading = true;

        // 创建 POST 请求的请求体，不包含 id 字段
        const requestBody = {
          title: this.currentRow.title,
          context: this.currentRow.context,
          mode: this.currentRow.mode
        };

        // 发送 POST 请求到 /save 路径
        const response = await axios.post(`/api/admin/tips/save`, requestBody, {
          headers: {
            'token': this.$cookies.get('token') // 通过请求头发送token
          }
        });

        // 处理正常响应
        this.$message.success('Tips成功添加');

        // 可能需要更新列表或执行其他相关操作
        // ...
        await this.fetchTips();

      } catch (error) {
        // 处理错误
        this.$message.error('Tips添加失败: ' + error.message);
      } finally {
        // 结束添加请求，无论成功或失败，设置loading为false
        this.loading = false;
      }
    },
    handleDialogClose() {
      // 对话框关闭时的处理
      this.currentRow = {}; // 清空当前行数据
      this.dialogVisible = false;
    },
    async fetchTips() {
      try {
        this.loading = true; // 开始加载数据前设置loading为true

        // 创建 POST 请求的请求体
        const requestBody = {
          title: this.searchForm.title,
          page: this.currentPage,
          size: this.pageSize
        };

        const response = await axios.post(`/api/admin/tips/page`, requestBody, {
          headers: {
            'token': this.$cookies.get('token')
          }
        });

        // 处理响应数据
        this.tipsList = response.data.data.map(tip => ({
          ...tip,
          createTime: this.formatDate(tip.createTime), // 假设您有一个formatDate方法
          updateTime: this.formatDate(tip.updateTime)
        }));

        this.totalTips = response.data.total;
      } catch (error) {
        // 处理错误
        this.$message.error('Error fetching tips: ' + error.message);
      } finally {
        this.loading = false; // 无论成功或失败，加载完成后设置loading为false
      }
    },
    handleSearch() {
      // 搜索触发重新获取数据
      this.fetchTips();
    },
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchTips();
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleString();
    },
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    }
  },
  mounted() {
    this.fetchTips();
  }
}
</script>

<style scoped>
.search-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.search-input {
  margin-right: 10px;
}

.app-container /deep/ .el-table th {
  background-color: #f5f7fa;
}

.app-container /deep/ .el-table td, .app-container /deep/ .el-table th {
  padding: 8px 0;
}

.app-container /deep/ .el-table .cell {
  line-height: 30px;
}

/* 为表格行添加样式 */
.el-table .el-table__row {
  line-height: 1.5!important; /* 设置行高 */
  max-height: 50px!important; /* 设置最大高度 */
  overflow: hidden!important; /* 隐藏溢出的内容 */
}

/* 为单元格内容添加样式 */
.el-table .cell {
  white-space: nowrap !important; /* 不允许内容换行 */
  text-overflow: ellipsis!important; /* 文本溢出时显示省略号 */
  overflow: hidden!important; /* 隐藏溢出的文本 */
}
/* 添加更多的自定义样式 */
</style>
